import React from 'react'

import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'

import { ArcadeButton, Header, spacing, Stack, Text } from '@cash-design-system/react'

const Container = styled.div`
  width: 100%;
  margin-bottom: ${spacing.xl};
`

const LinkButton = styled(ArcadeButton)<{ href: string }>`
  text-decoration: none;
`

const LoginButton = styled(LinkButton)`
  width: 108px;
`

const ButtonContent = styled.span`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  ${props => props.theme.typography.identifier};
  font-weight: 700; /* stylelint-disable-line @cash-web/no-hardcoded-font-styles */
`

const Banner = styled.section`
  background-color: ${props => props.theme.colors.background};
  border-radius: ${props => props.theme.border.radius.small};
  padding: 1.75rem ${spacing.xl} ${spacing.xl} ${spacing.xl};
  display: flex;
  flex-direction: column;
  row-gap: ${spacing.xl};

  ${props => props.theme.breakpoints.desktop} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    column-gap: ${spacing.xl};
  }
`

const LoginHeader = styled(Header)`
  color: ${props => props.theme.colors.textStandard};
`

const BannerText = styled(Text)`
  color: ${props => props.theme.colors.textStandard};
`

const LoginPrompt = () => {
  const { t } = useTranslation()
  return (
    <Container data-testid="login-prompt">
      <Banner>
        <Stack space={spacing.xs}>
          <LoginHeader variant="sectionTitle" as="h2">
            {t('Personalized help is one step away', { context: 'Login prompt title' })}
          </LoginHeader>
          <BannerText>
            {t('Log in to get articles and support suggestions specific to your account.', {
              context: 'Login prompt subtitle',
            })}
          </BannerText>
        </Stack>

        <LoginButton prominence="prominent" size={'default'} as="a" href="/login?redirect=support">
          <ButtonContent>
            <span> {t('Log in', { context: 'Login button' })}</span>
          </ButtonContent>
        </LoginButton>
      </Banner>
    </Container>
  )
}

export default LoginPrompt
